import Swiper from 'swiper';
import {Navigation} from "swiper/modules";
import {Pagination} from "swiper/modules";
import $ from 'jquery';
import lity from 'lity';

new Swiper('.component-jumbotron-slider .swiper', {
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
    },
  }
});
